import { useCallback, useEffect, useRef } from 'react';

import { useInlineEditContext } from '@/components/EditableSectionField/InlineEditContext';

export const useGuardActiveEditClose = (
	prefix: string,
	action?: () => void
) => {
	const ctx = useInlineEditContext();
	const pendingRef = useRef(false);

	const guardedAction = useCallback(() => {
		if (!action) return;

		const active = ctx?.activeFieldName;

		if (!active?.startsWith(prefix) || !ctx) {
			action();
			return;
		}

		if (!ctx.getActiveDirty()) {
			ctx.requestCloseActive();
			action();
			return;
		}

		pendingRef.current = true;
		ctx.requestCloseActive();
	}, [action, ctx, prefix]);

	useEffect(() => {
		if (!pendingRef.current) return;

		if (!ctx?.activeFieldName) {
			pendingRef.current = false;
			action?.();
			return;
		}

		if (!ctx?.pendingActivation) {
			pendingRef.current = false;
		}
	}, [ctx?.activeFieldName, ctx?.pendingActivation, action]);

	return guardedAction;
};
